<p-confirmdialog>
  <ng-template
    #headless
    let-message
    let-onAccept="onAccept"
    let-onReject="onReject">
    @if (message) {
      <div
        class="bg-surface-0 dark:bg-surface-900 flex flex-col items-center rounded-2xl px-8 pt-0 pb-8">
        <div
          class="-mt-10 inline-flex h-20 w-20 items-center justify-center rounded-full"
          [ngClass]="
            message.acceptButtonProps?.severity === 'danger'
              ? 'bg-red-500 text-white'
              : 'bg-primary text-primary-contrast'
          ">
          <ng-icon [name]="getIcon(message)" size="32" />
        </div>

        <span class="mt-6 mb-2 text-center text-xl font-bold">
          {{ message.header }}
        </span>
        <p class="text-muted-color mb-0 max-w-xs text-center text-sm">
          {{ message.message }}
        </p>

        <div class="mt-8 flex items-center gap-3">
          <p-button
            [label]="
              message.rejectButtonProps?.label ||
              message.rejectLabel ||
              'Cancelar'
            "
            [outlined]="true"
            severity="secondary"
            (onClick)="onReject()" />
          <p-button
            [label]="
              message.acceptButtonProps?.label ||
              message.acceptLabel ||
              'Confirmar'
            "
            [severity]="message.acceptButtonProps?.severity || 'primary'"
            (onClick)="onAccept()" />
        </div>
      </div>
    }
  </ng-template>
</p-confirmdialog>
